import React, { useState } from 'react'

import { getTheNightlyEmailVerifyActionPath } from '@news-mono/web-common'
import { tokens } from '@news-mono/design-tokens'
import { TNToastComponentProps } from '../../../../content'
import { TNToastComponent } from '../../../../content/TNToastNotification/TNToastNotification'
import {
    TextWrapper,
    BodyText,
    StyledCTAWardenButton,
    Heading,
} from './component.styled'

type VerifyEmailContentProps = {
    text: CTAText
    auth0Id: string
}

export const VerifyEmailContent = ({
    text,
    auth0Id,
}: VerifyEmailContentProps) => {
    const [emailSendAttempted, setEmailSendAttempted] = useState<Boolean>(false)
    const [emailStatusBanner, setEmailStatusBanner] =
        useState<TNToastComponentProps>({
            type: 'success',
            text: 'Email has been sent',
            useMaxWidth: false,
            forceMaxWidth: true,
        })

    const onClickEmailVerify = async () => {
        const request = 'send-verification-email'

        const response = await fetch(getTheNightlyEmailVerifyActionPath, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userId: auth0Id }),
        })
        if (!response.ok || response.status !== 201) {
            setEmailSendAttempted(true)
            setEmailStatusBanner({
                type: 'error',
                text: 'Something went wrong.',
                useMaxWidth: false,
                forceMaxWidth: true,
            })
            throw new Error(`Network error in ${request}`)
        }

        setEmailSendAttempted(true)
        setEmailStatusBanner({
            type: 'success',
            text: 'Email has been sent',
            useMaxWidth: false,
            forceMaxWidth: true,
        })
        return true
    }

    return (
        <>
            {emailSendAttempted && (
                <TNToastComponent
                    type={emailStatusBanner?.type}
                    text={emailStatusBanner?.text}
                    useMaxWidth={emailStatusBanner?.useMaxWidth}
                    forceMaxWidth={emailStatusBanner?.forceMaxWidth}
                />
            )}
            <TextWrapper>
                <Heading>{text.title}</Heading>
                <BodyText>{text.body}</BodyText>
            </TextWrapper>

            <StyledCTAWardenButton
                onClick={onClickEmailVerify}
                disabled={emailSendAttempted ? true : false}
                backgroundColors={{
                    default:
                        tokens.thenightly.colors.palette.utility.error.default,
                    hover: tokens.thenightly.colors.palette.utility.error.hover,
                }}
                roundEdges={true}
                useWidePadding={true}
            >
                {emailSendAttempted
                    ? 'RESEND VERIFICATION EMAIL'
                    : 'SEND VERIFICATION EMAIL'}
            </StyledCTAWardenButton>
        </>
    )
}
